import { Inject, Service } from 'vue-di-container';
import AxiosService from '@/services/axios';
import LoaderService from '@/services/loader';
import { Result } from '../models/Result';
import { PersonInfoModel } from '../models/PersonInfoModel';
import { OTPRefrenceDataModel } from '../models/OTPRefrenceDataModel';
import { PersonInfoRequestModel } from '@/models/PersonInfoRequestModel';

@Service()
export default class ExternalService {
  @Inject(AxiosService) public axiosService!: AxiosService;
  @Inject(LoaderService) public loaderService!: LoaderService;
  public async getPersonInfo(personInfoRequestModel: PersonInfoRequestModel): Promise<Result<PersonInfoModel>> {
    this.loaderService.ShowLoader();
    // let result = {} as any;
    try {
      const url = 'api/External/GetPersonInfo';
      const result = await this.axiosService.axiosInstance.post(url, personInfoRequestModel);
      return result.data;
    } catch (e) {
      throw e;
    } finally {
      this.loaderService.HideLoader();
    }
  }

  public async sendOTP(socialId: string, reference = ''): Promise<Result<OTPRefrenceDataModel>> {
    this.loaderService.ShowLoader();
    // let result = {} as any;
    try {
      const url = `api/External/SendOTP?socialId=${socialId}&reference=${reference}`;
      const result = await this.axiosService.axiosInstance.get(url);
      return result.data;
    } catch (e) {
      throw e;
    } finally {
      this.loaderService.HideLoader();
    }
  }

  public async checkLicenseExpiry(nationalId: string, licenseNumber: number) {
    this.loaderService.ShowLoader();
    try {
      const url = `api/External/CheckLicenseExpiry?nationalId=${nationalId}&licenseNumber=${licenseNumber}`;
      const result = await this.axiosService.axiosInstance.get(url);
      return result.data;
    } catch (e) {
      throw e;
    } finally {
      this.loaderService.HideLoader();
    }
  }
}
